"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const one_1 = require("remax/one");
const icon_1 = __importDefault(require("../icon"));
const common_1 = require("../common");
const prefixCls = common_1.getPrefixCls('rate');
const Rate = (props) => {
    const { count = 5, label, value = 0, onChange, readOnly, icon = 'favor', iconFill = 'favorfill', size = '48px', color = '#FFD700', } = props;
    const handleClick = (index) => {
        if (readOnly) {
            return;
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(index + 1);
    };
    const stars = react_1.useMemo(() => {
        if (!count) {
            return [];
        }
        return [...new Array(count).keys()];
    }, [count]);
    return (React.createElement(one_1.View, { className: prefixCls },
        label ? React.createElement(one_1.View, { className: `${prefixCls}-label` }, label) : null,
        React.createElement(one_1.View, { className: `${prefixCls}-value` }, stars.map((item, index) => (React.createElement(one_1.View, { key: index, className: `${prefixCls}-value-star`, onTap: () => {
                handleClick(index);
            } }, value >= index + 1 ? (React.createElement(icon_1.default, { type: iconFill, size: size, color: color })) : (React.createElement(icon_1.default, { type: icon, size: size, color: "#999" }))))))));
};
exports.default = Rate;
